import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";

const lesson: Lesson = {
  id: "b37a3ea2-648a-44bc-bc5c-a3ed4aad0122",
  publicId: "6",
  name: "Introduction to Psychoacoustics",
  difficulty: 1,
  contentTypes: { audio: true, interactive: false, video: false },
  body: [principle01, task01],
};

export default lesson;
